"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWalletVersion = void 0;
var react_1 = require("react");
var constants_1 = require("../constants");
var fetchWCWallets_1 = __importDefault(require("./fetchWCWallets"));
var VERSION_OVERRIDE = Object.freeze((_a = {},
    _a[constants_1.WalletIds.Valora] = 1,
    _a[constants_1.WalletIds.CeloWallet] = 2,
    _a[constants_1.WalletIds.CeloTerminal] = 2,
    _a[constants_1.WalletIds.CeloDance] = 2,
    _a));
function useWalletVersion(walletId) {
    // TODO: decide if to use v1 or v2 as a default for unknown wallectconnect? Or if to expose both
    var _a = (0, react_1.useState)(walletId ? null : 2), version = _a[0], setVersion = _a[1];
    (0, react_1.useEffect)(function () {
        if (!walletId) {
            return;
        }
        void (0, fetchWCWallets_1.default)().then(function (celoWallets) {
            var wallet = celoWallets.find(function (appEntry) { return appEntry.id === walletId; });
            if (wallet) {
                var versionFromRegistry = Math.max.apply(Math, wallet.versions.map(function (_) { return parseInt(_, 10); }));
                if (VERSION_OVERRIDE[walletId] &&
                    VERSION_OVERRIDE[walletId] !== versionFromRegistry) {
                    console.warn("Override version found in registry(" + versionFromRegistry + ") by hard-coded version(" + VERSION_OVERRIDE[walletId] + ") for " + wallet.name);
                    setVersion(VERSION_OVERRIDE[walletId]);
                }
                else {
                    setVersion(versionFromRegistry);
                }
            }
            else if (!VERSION_OVERRIDE[walletId]) {
                throw new Error('Unknown wallectconnect wallet');
            }
        });
    }, [walletId]);
    return version;
}
exports.useWalletVersion = useWalletVersion;
//# sourceMappingURL=useWalletVersion.js.map